import { Component, OnInit, inject, signal } from '@angular/core';
import { UserDataService } from '../../../state-and-data-handling/user-data.service';
import { faPenToSquare } from '@fortawesome/pro-regular-svg-icons';
import { filter } from 'rxjs/operators';
import { UserOperation } from '../../../../../core/enums/user-operation';
import { ShiveDialogService } from '../../../../../core/services/controls/shive-dialog.service';
import { CostRateHistoryDialogComponent } from '../../../../project/project-details/project-edit/dialogs/cost-rate-history-dialog/cost-rate-history-dialog.component';
import { CostRateEntryModel } from '../../../../../core/models/user/cost-rate-entry.model';

@Component({
  selector: 'app-user-profile-salary-data',
  templateUrl: './user-profile-salary-data.component.html',
  standalone: false,
})
export class UserProfileSalaryDataComponent implements OnInit {
  // Signals
  costRateValue = signal(-1);

  // Constants
  public readonly faPenToSquare = faPenToSquare;

  // DI
  private readonly userDataService = inject(UserDataService);
  private readonly shiveDialogService = inject(ShiveDialogService);

  ngOnInit(): void {
    const userClone = this.userDataService.getUserClone()!;
    const costRateHistory = userClone.costRateEntries;
    this.costRateValue.set(costRateHistory[costRateHistory.length - 1].rate!);
  }

  public openNewCostRateDialog(): void {
    const ref = this.shiveDialogService.open({
      title: 'Mitarbeiterkosten',
      content: CostRateHistoryDialogComponent,
      width: 572,
      offsetX: 80,
    });

    const userClone = this.userDataService.getUserClone()!;

    const dialogComponent = ref.content.instance as CostRateHistoryDialogComponent;
    dialogComponent.costRateHistory = userClone.costRateEntries.slice();
    dialogComponent.user = userClone;

    ref.result
      .pipe(filter((dialogResult) => dialogResult !== UserOperation.Cancel))
      .subscribe((dialogResult: CostRateEntryModel[]) => {
        userClone.costRateEntries = [...dialogResult];
        this.costRateValue.set(
          userClone.costRateEntries[userClone.costRateEntries.length - 1].rate!,
        );
        this.userDataService.updateUser(userClone);
        this.userDataService.userOperationConducted$.next(true);
      });
  }
}
